// NOTE: This file gets overwritten by buildspec-post.yml
export const COGNITO = {
  REGION: 'ap-southeast-2',
  USER_POOL_ID: 'ap-southeast-2_oklzkVrWM',
  APP_CLIENT_ID: '4oscmn1pdvbeq8b1h79eq2vms7',
  API_HOST: 'https://6vvrx9wbc8.execute-api.ap-southeast-2.amazonaws.com/T',
  USER_POOL_DOMAIN: 'sydneyuni-pushnotification-admin-test'
};
export const ENV = {
  ENV_NAME: 'T'
}
